import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import apiV2 from "api-v2";
import type { Company2faSettings } from "../types/Mfa.type";

export const COMPANY_2FA_SETTINGS_KEY = "company-2fa-settings";

const fetchCompany2faSettings = async (): Promise<Company2faSettings> => {
	const response = await apiV2.get("/company/2fa-settings");
	return (response.data as { data?: Company2faSettings })?.data ?? response.data;
};

export const useCompany2faSettings = (enabled = true) =>
	useQuery<Company2faSettings>({
		queryKey: [COMPANY_2FA_SETTINGS_KEY],
		queryFn: fetchCompany2faSettings,
		enabled,
	});

const updateCompany2faSettings = async (
	payload: Company2faSettings
): Promise<Company2faSettings> => {
	const response = await apiV2.put("/company/2fa-settings", payload);
	return (response.data as { data?: Company2faSettings })?.data ?? response.data;
};

export const useUpdateCompany2faSettings = () => {
	const queryClient = useQueryClient();

	return useMutation<Company2faSettings, Error, Company2faSettings>({
		mutationFn: updateCompany2faSettings,
		onSuccess: (data) => {
			queryClient.setQueryData([COMPANY_2FA_SETTINGS_KEY], data);
		},
	});
};
